import { useContext, createContext } from "react";
import { StateNavigator, HTML5HistoryManager } from "navigation";
import { NavigationHandler, SceneView } from "navigation-react";
import Login from "./Login";
import ScreeningContentManager from "./ScreeningContentManager";
import ScreeningClientManager from "./ScreeningClientManager";
import DashboardContent from "./DashboardContent";
import DashboardRequest from "./DashboardRequest";
import ClientRegister from "./ClientRegister";
import "../src/styles.css";

const PermContext = createContext(null);

export const usePermissions = () => {
  return useContext(PermContext);
};

const stateNavigator = new StateNavigator(
  [
    { key: "login", route: "" },
    { key: "screeningcontentmanager", route: "screening-content-manager" },
    { key: "screeningclientmanager", route: "screening-client-manager" },
    { key: "clientregister", route: "client-register" },
    { key: "dashboardcontent", route: "dashboard-content" },
    { key: "dashboardrequest", route: "dashboard-request" },
  ],
  new HTML5HistoryManager()
);
stateNavigator.start();

const App = () => {
  return (
    <NavigationHandler stateNavigator={stateNavigator}>
      <SceneView active="login">
        <Login />
      </SceneView>
      <SceneView active="screeningcontentmanager">
        <ScreeningContentManager />
      </SceneView>
      <SceneView active="screeningclientmanager">
        <ScreeningClientManager />
      </SceneView>
      <SceneView active="clientregister">
        <ClientRegister />
      </SceneView>
      <SceneView active="dashboardcontent">
        <DashboardContent />
      </SceneView>
      <SceneView active="dashboardrequest">
        <DashboardRequest />
      </SceneView>
    </NavigationHandler>
  );
};

export default App;
